import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { adminCreateIngredient, adminSearchIngredients } from '@api/adminIngredients';
import {
  IAdminCreateIngredientPayload,
  IAdminCreateIngredientResult,
  IAdminIngredientsSearchResult,
} from '@interfaces/adminIngredients';
import { IFetchListRequestProps } from '@interfaces/common';

import { buildAdminSearchIngredientsPayload } from './utils';

export const handleGetAdminIngredientsSearch = createAsyncThunk<
  AxiosResponse<IAdminIngredientsSearchResult>,
  IFetchListRequestProps
>('getAdminIngredientsSearch', props =>
  adminSearchIngredients(buildAdminSearchIngredientsPayload(props)),
);

export const handleAdminCreateIngredient = createAsyncThunk<
  AxiosResponse<IAdminCreateIngredientResult>,
  IAdminCreateIngredientPayload
>('adminCreateIngredient', adminCreateIngredient);
